import AboutSection from '../../Sections/AboutSection/AboutSection';
import './AboutPage.css';
import React from 'react';

export default function AboutPage(){
    return(
        <>
            <AboutSection/>
        </>
    );
}